import _values from 'lodash.values';

export function values(value: any): any[] {
  return _values(value);
}
